<div
  class="row component-card align-items-center mt-3"
  *ngFor="let item of data.details.services"
>
  <div class="col-8 col-md-4 m-auto">
    <img class="w-100" [src]="item.imageIconPath" [alt]="item.imageAlt" />
  </div>
  <div class="col-12 col-md-8">
    <h1>{{ item.titleTr }}</h1>
    <h5 class="mb-4">
      {{ item.summary }}
    </h5>
    <a
      class="btn"
      [href]="getDetailsUrl(item)"
      *ngIf="data.details.isDetails"
      >{{ "details" | translate }}</a
    >
  </div>
</div>
